export default "__VITE_ASSET__Cr1rf40B__"